// reactstrap components
import { Container, Row, Col } from "reactstrap";

const Header = (props) => {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="8" md="10">
                <h1 className="display-2 text-white">{props.title}</h1>
                <div className="d-flex text-white mt-0 mb-5 w-100">
                  {props.description}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
